<template>
  <div class="position-relative" style="min-height: 100vh; overflow-x: hidden">
    <Header />
    <b-container style="margin-bottom: 80px">
      <b-form-input
        class="mb-3"
        v-if="ownedContentsCount >= 30"
        v-model="searchString"
        debounce="300"
        variant="dark"
        :placeholder="placeholder"
        type="search"
      />
      <b-row
        deck
        v-if="$store.state.loading"
        class="text-center justify-content-center mt-5"
      >
        <b-spinner />
      </b-row>
      <div v-else-if="filteredContents.length">
        <b-row deck class="text-center justify-content-center py-2">
          <b-col
            xs="12"
            sm="4"
            md="3"
            lg="2"
            xl="2"
            v-for="(item, i) in filteredContents"
            :key="i"
            class="my-1"
          >
            <Content :item="item" class="h-100" />
          </b-col>
        </b-row>
      </div>
      <div class="h3 text-center" v-else>
        Sorry, No Content Found
      </div>
    </b-container>
    <Footer />
  </div>
</template>
<script>
import { mapState } from "vuex"
import fuzzy from "fuzzy"

const options = {
  extract: (el) => {
    return el.contentName || el.byLine || el.shortBlurb
  },
}

export default {
  components: {
    Content: () => import("../components/Content"),
    Header: () => import("../components/Header"),
    Footer: () => import("../components/Footer"),
  },
  name: "Library",
  data() {
    return {
      searchString: "",
    }
  },
  computed: {
    ...mapState(["eJSON"]),
    placeholder() {
      return `Search ${this.filteredContents.length} items`
    },
    contents() {
      return this.$store.state.contentForEnvironment?.content
    },
    ownedContentsCount() {
      return this.contents?.filter(
        (e) => e.playable && e.userActiveAccess && !e.bundleContent,
      )?.length
    },
    filteredContents() {
      let contents = this.contents
      if (!contents?.length) {
        return []
      }
      contents = contents.filter(
        (e) => e.playable && e.userActiveAccess && !e.bundleContent,
      )

      if (!this.searchString?.trim()) {
        return contents
      }

      let result = fuzzy.filter(
        this.searchString?.trim(),
        contents || [],
        options,
      )
      return result ? result.map((found) => found.original) : []
    },
  },
}
</script>
